<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Modelos Personalizados</h1>
                                    <p class="modern-subtitle">Crie, gerencie e atualize modelos alinhados aos requisitos do processo.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex gap-4">
                                <button @click="abrirModalInclusao" class="modern-btn modern-btn-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Novo modelo
                                </button>
                                <div class="search-box flex-grow-1">
                                    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                    <input v-model="pagFilter" type="text" class="modern-search-input" placeholder="Buscar por nome">
                                </div>
                            </div> <!-- custom-table-header -->
                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <!-- Header -->
                                <thead>
                                    <tr>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 30%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Modelo</span>

                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Data de Inclusão</span>

                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Última Edição</span>

                                            </div>
                                        </th>
                                        <th scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 10%;">Ações</th>
                                    </tr>
                                </thead>
                                <!-- Body -->
                                <tbody>
                                    <tr v-for="(item, index) in lstGrid" :key="index">
                                        <td data-label="Modelo" class="text-left">
                                            <div class="model-title">{{ item.dadosGrid.nmModeloArtefato }}</div>
                                            <div class="model-subtext">Identificador: {{ item.dadosGrid.idModeloArtefatoPersonalizado }}</div>
                                        </td>
                                        <td data-label="Data de Inclusão" class="text-center">
                                            <CirculoUsuario class="mb-2" :usuario="item.usuario"></CirculoUsuario>
                                            <p class="mb-0">
                                                {{ formatarData(item.dadosGrid.dtInclusao) }}
                                            </p>
                                        </td>
                                        <td data-label="Utima Edição" class="text-center">
                                            <CirculoUsuario class="mb-2" :usuario="item.usuarioAlteracao"></CirculoUsuario>
                                            <p class="mb-0">
                                                {{ formatarData(item.dadosGrid.dtAlteracao) }}
                                            </p>
                                        </td>
                                        <td data-label="Ações" class="text-center" style="white-space: nowrap ">
                                            <div class="action-buttons vertical">
                                                <button class="action-btn action-btn-light" @click="download(item.dadosGrid)" title="Download">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M.5 9.9a.5.5 0 0 1 .5-.5h3V1.5a.5.5 0 0 1 1 0v7.9h3a.5.5 0 0 1 .336.872l-4 3.9a.5.5 0 0 1-.672 0l-4-3.9A.5.5 0 0 1 .5 9.9zm9 3.1a.5.5 0 0 1 .5-.5h4.5a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5z" />
                                                    </svg>
                                                    Download
                                                </button>
                                                <button @click="abrirDetalhesSyncfusion(item.dadosGrid.idModeloArtefatoPersonalizado)"
                                                        class="action-btn action-btn-view"
                                                        title="Editar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                    </svg>
                                                    Editar
                                                </button>
                                                <button v-if="item.dadosGrid.dsLoginInclusao == user.usuario.dsLogin || isAdmContrato"
                                                        @click="deletar(item.dadosGrid.idModeloArtefatoPersonalizado)"
                                                        class="action-btn action-btn-delete"
                                                        title="Excluir">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                    Excluir
                                                </button>
                                                <button class="action-btn action-btn-light d-none" @click="testeFormatacao(item.dadosGrid)" title="Teste">
                                                    Teste Formatação
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="lstGrid.length === 0">
                                        <td colspan="8" class="text-center">Nenhum registro encontrado.</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>
                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box',page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div> <!-- pagination-controll -->
                                <span class="footer-records-text">Registros encontrados: {{ qtdRegistros }}</span>
                            </div> <!-- custom-table-footer -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <div v-if="mostrarModalInclusao" class="modal-overlay">
            <div class="modal-content bg-white rounded-lg shadow-lg p-6 w-[1000px] text-left modern-modal modern-modal-inline">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                        @click="mostrarModalInclusao = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="modal-modern-header">
                    <div class="header-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="header-text">
                        <h2>Novo Modelo Personalizado</h2>
                        <p>Selecione a legislação, o modelo e escolha a fonte do arquivo para importar ou utilizar a estrutura padrão.</p>
                    </div>
                </div>

                <div class="modal-modern-body">
                    <div class="form-grid form-grid-2">
                        <div class="form-group">
                            <label for="legislacao-select" class="form-label">Legislação</label>
                            <select id="legislacao-select"
                                    class="form-control w-full"
                                    v-model="legislacaoSelecionadaId"
                                    :class="{ 'border-danger': camposInvalidos.legislacaoSelecionadaId }">
                                <option disabled value="">Selecione uma Legislação</option>
                                <option v-for="(leg, index) in legislacoes" :key="index" :value="leg.idLegislacao">
                                    {{ leg.dsNome }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="modeloartefato-select" class="form-label">Modelo</label>
                            <select id="modeloartefato-select"
                                    class="form-control w-full"
                                    v-model="idModeloArtefato"
                                    :class="{ 'border-danger': camposInvalidos.idModeloArtefato }">
                                <option disabled value="">Selecione um Modelo</option>
                                <option v-for="(item, index) in lstModelosArtefato" :key="index" :value="item.idModeloArtefato">
                                    {{ item.nmModelo }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-label">Origem do arquivo</label>
                        <div class="toggle-group">
                            <button type="button"
                                    :class="['toggle-btn', tpArquivo==='s' ? 'active' : '']"
                                    @click="tpArquivo='s'">
                                Utilizar modelo SollAI
                            </button>
                            <button type="button"
                                    :class="['toggle-btn', tpArquivo==='u' ? 'active' : '']"
                                    @click="tpArquivo='u'">
                                Enviar arquivo Word
                            </button>
                        </div>
                    </div>

                    <div v-if="tpArquivo == 'u'" class="upload-section">
                        <ImputUploadS3 :reset="resetUpload"
                                       :labelText="'Selecionar Arquivo'"
                                       @onSave="setUploadFile"
                                       @onDelete="deleteUploadFile"
                                       :destino="'ModeloArtefatoPersonalizado'"
                                       :maxFileSize="800"
                                       :multiple="false"
                                       :id="'input_file_upload'"
                                       :whoFiles="'.doc,.docx'"></ImputUploadS3>
                    </div>

                    <div class="info-chip">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                            <circle cx="8" cy="4.5" r="1" />
                        </svg>
                        Arquivos enviados devem estar no formato `.doc` ou `.docx` e ter no máximo 800 MB.
                    </div>
                </div>

                <div class="modal-modern-footer">
                    <button class="modern-btn modern-btn-primary w-100" @click="salvarModeloPersonalizado">
                        Salvar modelo
                    </button>
                </div>
            </div> <!-- modal-content -->
        </div>  <!-- modal-overlay -->

        <div v-if="false" class="modal-overlay">
            <div class="modal-content bg-white rounded-lg shadow-lg p-6 text-left modal-edicao">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                        @click="fecharEditor">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div style="width:100%; min-height:90vh; height: 100%" id="placeholder">

                </div>

                <!-- Linha 4: Botões -->
                <div class="mt-4 d-none">
                    <button class="btn btn-primary w-100">
                        Salvar
                    </button>
                </div>
            </div> <!-- modal-content -->
        </div>  <!-- modal-overlay -->

        <div :class="'modal-overlay '+(mostrarModalEditar?'':'d-none' )">
            <div class="modal-content bg-white rounded-lg shadow-lg text-left modal-edicao">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                        @click="fecharEditor">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="viewer-layout">


                    <div class="docx-wrapper px-1" :class="{ 'is-loading': editorBusy }" @dragover.prevent @drop="onDrop">
                        <div v-if="editorBusy" class="editor-overlay">
                            <div class="overlay-content">
                                <svg class="spinner" viewBox="0 0 50 50" aria-label="Carregando">
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                                </svg>
                                <p>Carregando documento…</p>
                            </div>
                        </div>

                        <ejs-documenteditorcontainer ref="docx"
                                                     :serviceUrl="`${urlApi}/DOCXEditor/`"
                                                     
                                                     height="97%"
                                                     width="100%"
                                                     locale="pt-BR"
                                                     @created="onEditorCreated"
                                                     @beforeXmlHttpRequestSend="beforeSend"
                                                     @toolbarClick="onToolbarClick" 
                                                     :documentEditorSettings="settings"
                                                     :enableToolbar='true'
                                                     :toolbarMode="'Ribbon'" :ribbonLayout="'Classic'"
                                                     />
                    </div>

                    <aside class="side-panel">
                        <div class="panel-header">
                            <div class="header-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                </svg>
                            </div>
                            <div class="header-content">
                                <h3 class="titulo-artefato">
                                    {{ nomeModeloEmEdicao }}
                                </h3>
                            </div>
                        </div>

                        <div class="info-card status-card tags-card">
                            <div class="card-title">
                                <i class="fas fa-tags"></i>
                                Termos SollAI
                            </div>

                            <div class="search-box tags-search-box">
                                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                <input v-model="filtroTag"
                                       type="text"
                                       class="modern-search-input"
                                       placeholder="Buscar tag">
                            </div>

                            <ul class="tyn-aside-list tags-list">
                                <li class="tyn-aside-item js-toggle-main"
                                    :data-bs-toggle="temDescricaoTag(item) ? 'popover' : ''"
                                    data-bs-placement="top"
                                    :data-bs-content="getDataBs(item)"
                                    v-for="(item, index) in lstTagsFiltradas"
                                    :key="getTagKey(item, index)">
                                    <div :class="'tyn-media-group '+(idDragging == item.idModeloArtefatoTag?'dragging':'')" draggable="true" @dragstart="handleDragStart($event, item)" @dragend="handleDragEnd($event)">
                                        <div class="tyn-media tyn-size-sm">
                                            <i class="fas fa-tag"></i>
                                        </div>
                                        <div class="tyn-media-col">
                                            <div class="content" v-if="item.dsTag">{{ getNomeTag(item) }}</div>
                                            <div class="content-descricao" v-if="temDescricaoTag(item)">{{ item.dsDescricao }}</div>
                                        </div>
                                        <div class="tyn-media-option">
                                            <ul class="tyn-media-option-list">
                                                <li class="d-flex">
                                                    <button class="btn btn-icon btn-md btn-success-add me-2" @click="inserirTag(item.dsTag)">
                                                        <i class="fas fa-share fa-flip-horizontal"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="acoes-section">
                            <button class="btn-action btn-outline-primary"
                                    @click="salvarEdicao"
                                    :disabled="loading || editorBusy">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                     class="bi bi-save" viewBox="0 0 16 16">
                                    <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4.5L10.5 1H2zm9 2v3H5V3h6z" />
                                    <path d="M4.5 9.5A1.5 1.5 0 1 1 6 11a1.5 1.5 0 0 1-1.5-1.5z" />
                                </svg>
                                <span>Salvar alterações</span>
                            </button>
                        </div>

                    </aside>

                </div>

                <!-- Linha 4: Botões -->
                <div class="mt-4 d-none">
                    <button class="btn btn-primary w-100">
                        Salvar
                    </button>
                </div>
            </div> <!-- modal-content -->
        </div>  <!-- modal-overlay -->
    </div> <!-- tyn-root-->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import CirculoUsuario from '@/components/CirculoUsuario'

    import axios from 'axios'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import ImputUploadS3 from '@/components/Input_Upload_s3Centralizado'
    import Swal from 'sweetalert2'
    //import DataTable from '@/components/DataTable.vue'

    // syncfusion
    import { L10n, setCulture } from '@syncfusion/ej2-base'
    import ptBR from '@syncfusion/ej2-locale/src/pt-BR.json'
    import { PdfViewer, Navigation, Magnification, Print, TextSelection, LinkAnnotation, BookmarkView, ThumbnailView } from '@syncfusion/ej2-pdfviewer'

    PdfViewer.Inject(Toolbar, Navigation, Magnification, Print, TextSelection, LinkAnnotation, BookmarkView, ThumbnailView)

    // Document Editor (Vue)
    import {
        DocumentEditorContainerComponent as EjsDocumenteditorcontainer,
        Toolbar, SpellChecker, Ribbon
    } from '@syncfusion/ej2-vue-documenteditor'

    import { uploadFileToS3 } from '@/services/fileUploadService'
    L10n.load(ptBR); setCulture('pt-BR')

    const TAG_SOLLAI_HIGHLIGHT = 'Turquoise'

    export default {
        name: 'ModeloPersonalizado',
        components: { Header, Modais, ImputUploadS3, CirculoUsuario, 'ejs-documenteditorcontainer': EjsDocumenteditorcontainer },
        provide: { DocumentEditorContainer: [Toolbar, Ribbon, SpellChecker] },
        computed: {
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim';
            },

            editor() {
                return this.$refs.docx?.ej2Instances?.documentEditor || null
            },

            nomeModeloEmEdicao() {
                const modelo = this.modeloArtefatoPersonalizado
                return (modelo && modelo.nmModeloArtefato) || 'Modelo'
            },

            lstTagsFiltradas() {
                const termo = (this.filtroTag || '').trim().toLowerCase();
                if (!termo) return this.lstTags || [];

                return (this.lstTags || []).filter(item => {
                    const nome = this.getNomeTag(item).toLowerCase();
                    const descricao = (item?.dsDescricao || '').toLowerCase();
                    const tag = (item?.dsTag || '').toLowerCase();
                    return nome.includes(termo) || descricao.includes(termo) || tag.includes(termo);
                });
            }
        },
        data: function () {
            return {
                pagFilter: '',
                filtroTag: '',
                lstGrid: [],

                legislacoes: [],
                lstModelosArtefato: [],
                qtdRegistros: 0,

                mostrarModalInclusao: false,
                mostrarModalEditar: false,


                currentPage: 0,
                pageSize: 7,
                debounceTimeout: null,
                orderColumn: 'tbGptProcessos.nrProcesso',
                orderDirection: 'DESC',
                camposInvalidos: {
                    legislacaoSelecionadaId: false,
                    idModeloArtefato: false,
                    tpArquivo: false,
                },
                nomeUsuario: '',

                // FORM MODELO
                legislacaoSelecionadaId: '',
                idModeloArtefato: '',
                tpArquivo: 's',

                // EDITOR
                docEditor: null,
                tagBeingDragged: null,

                // UPLOAD
                resetUpload: false,


                // syncfusion
                lstTags: [],
                loading: false,
                editorBusy: false,
                urlApi, 
                settings: { allowDragAndDrop: true, preserveDocumentFormatting:false, optimizeSfdt: true },
                modeloArtefatoPersonalizado: null,
                idDragging: null,

                modeloSelecionado: null,
            }
        },
        methods: {
            // UPLOAD
            setUploadFile(urlArquivoS3) {
                this.urlArquivoS3 = urlArquivoS3.key;
                this.fileName = urlArquivoS3.fileName;
            },

            deleteUploadFile() {
                this.urlArquivoS = null;
                this.fileName = null;
            },

            // FIM UPLOAD


            load() {
                this.getGrid();
                this.getLegislacoes();
            },

            getGrid() {
                let $this = this;
                //const orderBy = $this.orderColumn
                //    ? `${$this.orderColumn} ${$this.orderDirection}`
                //    : null;

                axios.get(`${urlApi}/ModeloArtefatoPersonalizado/GetGrid`, {
                    params: {
                        index: $this.currentPage,
                        take: $this.pageSize,
                        dsTermo: $this.pagFilter,
                        //orderBy: orderBy
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstGrid = result.rows.map(p => ({
                                ...p,
                            }));
                            $this.qtdRegistros = result.qtdRecords;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar modelos personalizados!", "warning");
                    });
            },

            ordenarPorColuna(coluna) {
                if (this.orderColumn === coluna) {
                    this.orderDirection = this.orderDirection === 'ASC' ? 'DESC' : 'ASC';
                } else {
                    this.orderColumn = coluna;
                    this.orderDirection = 'ASC';
                }
                this.getGrid();
            },

            getLegislacoes() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/GetLegislacoesProduto/`, { showLoading: false, params: { cdIdentificador: 'PI' } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacoes = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar Legislações!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            abrirModalInclusao() {
                this.mostrarModalInclusao = true;
            },

            salvarModeloPersonalizado() {
                this.camposInvalidos.tpArquivo = !this.tpArquivo?.trim();
                this.camposInvalidos.legislacaoSelecionadaId = !this.legislacaoSelecionadaId;
                this.camposInvalidos.idModeloArtefato = !this.idModeloArtefato;

                const invalido = Object.values(this.camposInvalidos).some(campo => campo);

                if (invalido) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }

                if (this.tpArquivo == 'u' && (this.urlArquivoS3 == null || this.urlArquivoS3 == '')) {
                    avisoErro("Realize o envio do arquivo antes de salvar.");
                    return;
                }

                const payload = {
                    idLegislacao: parseInt(this.legislacaoSelecionadaId),
                    idModeloArtefato: parseInt(this.idModeloArtefato),
                    tpArquivo: this.tpArquivo,
                    urlArquivoS3: this.urlArquivoS3,
                    fileName: this.fileName,
                };

                axios.post(`${urlApi}/ModeloArtefatoPersonalizado/Post`, payload)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Modelo Personalizado criado com sucesso!", "success");
                            this.getGrid();
                            this.mostrarModalInclusao = false;

                            this.legislacaoSelecionadaId = '';
                        } else {
                            const erroMsg = res.data.msg || "Erro ao salvar Modelo Personalizado!";
                            avisoErro(erroMsg);
                            //avisoToast(erroMsg, "warning");
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            const response = err.response.data;
                            const mensagem = response.msg || "Erro ao salvar Modelo Personalizado!";
                            const motivo = response.errors?.[0];

                            if (motivo != "") {
                                avisoErro(mensagem + '. ' + motivo);
                            } else {
                                avisoErro(mensagem);
                            }
                            //avisoToast("Erro ao salvar Modelo Personalizado!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });

            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getGrid();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getGrid();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getGrid();
                }
            },

            deletar(id) {
                Swal.fire({
                    title: 'Tem certeza?',
                    text: 'Essa ação não poderá ser desfeita!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.delete(`${urlApi}/ModeloArtefatoPersonalizado/Delete`, {
                            params: { id: id }
                        })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Modelo Personalizado excluído com sucesso!", "success");
                                    this.getGrid();
                                } else {
                                    const erroMsg = res.data.msg || "Erro ao excluir Modelo Personalizado!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                }
                            })
                            .catch(err => {
                                if (err.response && err.response.data) {
                                    avisoErro(err.response.data);
                                    avisoToast("Erro ao excluir Modelo Personalizado!", "warning");
                                } else {
                                    avisoErro(err.message || "Erro desconhecido");
                                }
                            });
                    }
                });
            },

            

            abrirDetalhes(idModeloArtefatoPersonalizado) {
                const modelo = this.lstGrid.find(m => m.dadosGrid.idModeloArtefatoPersonalizado === idModeloArtefatoPersonalizado);
                if (!modelo) return;

                let $this = this;

                axios.get(`${urlApi}/ModeloArtefatoPersonalizado/Get/${modelo.dadosGrid.idModeloArtefatoPersonalizado}`, {

                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            var config = {
                                idModeloArtefatoPersonalizado: result.idModeloArtefatoPersonalizado,
                                document: {
                                    fileType: "docx",
                                    key: result.dsHash,
                                    title: result.nmArquivo,
                                    url: urlApi + "/ModeloArtefatoPersonalizado/Download/?idModeloArtefatoPersonalizado=" + result.idModeloArtefatoPersonalizado + "&token=" + $this.user.accessToken ,
                                    permissions: {
                                        chat: false,
                                        comment: false,
                                        modifyContentControl: true,
                                        protect: false,
                                        review: false,
                                    },
                                },
                                documentType: "word",

                                editorConfig: {
                                    mode: "edit",
                                    lang: "pt-BR",
                                    callbackUrl: urlApi + "/ModeloArtefatoPersonalizado/callback?token=" + $this.user.accessToken,
                                    customization: {
                                        advanced: false,
                                        //forcesave: true,
                                        anonymous: {
                                            request: false,
                                        },
                                        comments: false,
                                        "customer": {
                                            "address": "-",
                                            "info": "Editor de arquivos SollAI",
                                            "logo": "https://app.sollai.com.br/assets/images/sollai/logo.png",
                                            "logoDark": "https://app.sollai.com.br/assets/images/sollai/logo_white.png",
                                            "mail": "contato@sollai.com.br",
                                            "name": "SollAI",
                                            "phone": "123456789",
                                            "www": "sollai.com",
                                        },
                                    },

                                    plugins: {
                                        autostart: [
                                            "asc.{CD4E451C-6928-43A4-B641-ECBBF688AC76}",
                                        ],
                                        options: {
                                            "asc.{CD4E451C-6928-43A4-B641-ECBBF688AC76}": {
                                                "idModeloArtefato": result.idModeloArtefato,
                                                "urlTags": urlApi + "/ModeloArtefatoPersonalizado/GetTags?idModeloArtefato=" + result.idModeloArtefato + "&token=" + $this.user.accessToken
                                            }
                                        }
                                    },

                                    user: {
                                        id: $this.user.usuario.dsLogin,
                                        name: $this.user.usuario.nmUsuario,
                                    },
                                },
                            };

                            axios.post(`${urlApi}/ModeloArtefatoPersonalizado/GetToken`, config)
                                .then(res => {
                                    if (res.data.success) {
                                        var payload = res.data.data;

                                        $this.payload = payload;
                                        $this.mostrarModalEditar = true;
                                        $this.$nextTick(function () {
                                            $this.docEditor = new window.DocsAPI.DocEditor("placeholder", payload);
                                            window.docEditor = $this.docEditor;
                                        });

                                    } else {
                                        console.warn("Resposta sem sucesso");
                                    }
                                })
                                .catch(err => {
                                    if (err.response && err.response.data) {
                                        avisoErro(err.response.data);
                                        avisoToast("Erro ao carregar Legislações!", "warning");
                                    } else {
                                        avisoErro(err.message || "Erro desconhecido");
                                    }
                                    $this.loading.hide();
                                });
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar Modelo Personalizado!", "warning");
                    });


            },

            download(modeloArtefatoPersonalizado) {
                var nmArquivo = modeloArtefatoPersonalizado.nmArquivo;
                axios({
                    url: `${urlApi}/ModeloArtefatoPersonalizado/Download/?` + "idModeloArtefatoPersonalizado=" + modeloArtefatoPersonalizado.idModeloArtefatoPersonalizado + "&token=" + this.user.accessToken,

                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            testeFormatacao(modeloArtefatoPersonalizado) {
                var nmArquivo = modeloArtefatoPersonalizado.nmArquivo;
                axios({
                    url: `${urlApi}/ModeloArtefatoPersonalizado/TesteModeloPersonalizado/?` + "id=" + modeloArtefatoPersonalizado.idModeloArtefatoPersonalizado,

                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res);
                        }
                    });
            },

            generateDocKey(id) {
                const raw = id + "_" + Date.now();
                let key = btoa(raw);

                return key.replace(/[^a-zA-Z0-9]/g, "").substring(0, 20);
            },

            formatarData(dataISO) {
                if (!dataISO) return '';
                const data = new Date(dataISO);
                let hora = data.toLocaleTimeString('pt-BR').split(":")
                return data.toLocaleDateString('pt-BR') + " " + (hora[0] + ":" + hora[1]);
            },

            carregaModeloArtefato() {
                let $this = this;
                axios.get(`${urlApi}/ModeloArtefatoPersonalizado/GetModelosProcesso/`, { showLoading: false, params: { idLegislacao: $this.legislacaoSelecionadaId } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstModelosArtefato = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar modelos!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            fecharEditor() {
                let $this = this;
                $this.mostrarModalEditar = false;
                $this.modeloSelecionado = null;
                $this.liberarDocumentoEditor();
                $this.load();
            },

            // syncfusion
            abrirDetalhesSyncfusion(idModeloArtefatoPersonalizado) {
                const modelo = this.lstGrid.find(m => m.dadosGrid.idModeloArtefatoPersonalizado === idModeloArtefatoPersonalizado);
                if (!modelo) return;

                let $this = this;
                $this.modeloSelecionado = modelo.dadosGrid;
                $this.editorBusy = false;
                axios.get(`${urlApi}/ModeloArtefatoPersonalizado/Get/${modelo.dadosGrid.idModeloArtefatoPersonalizado}`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.modeloArtefatoPersonalizado = result;
                            $this.mostrarModalEditar = true;
                            $this.$nextTick(async () => {
                                await $this.carregaTags($this.modeloArtefatoPersonalizado);
                                await $this.abrirDocumento($this.modeloArtefatoPersonalizado.urlArquivo);
                            });


                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar Modelo Personalizado!", "warning");
                    });
            },

            async carregaTags(modeloArtefatoPersonalizado) {
                try {
                    this.filtroTag = '';
                    const res = await axios.get(`${urlApi}/ModeloArtefatoPersonalizado/GetTags?idModeloArtefato=` + modeloArtefatoPersonalizado.idModeloArtefato + "&token=" + this.user.accessToken)
                    if (res.data.success) {
                        this.lstTags = this.normalizarTagsLista(res.data.data);
                        this.montaPopover();
                    } else {
                        console.warn("Resposta sem sucesso");
                    }
                } catch (err) {
                    if (err.response && err.response.data) {
                        avisoErro(err.response.data);
                        avisoToast("Erro ao carregar modelos!", "warning");
                    } else {
                        avisoErro(err.message || "Erro desconhecido");
                    }
                    this.loading.hide();
                }
            },

            async abrirDocumento(url) {
                if (!url) { this.setError('URL do artefato vazia.'); return }

                const ext = (url.split('?')[0].split('#')[0].split('.').pop() || '').toLowerCase()
                if (ext === 'pdf') {
                    this.setError('Este artefato está em PDF. Use o visualizador de PDF para revisão.')
                    return
                }

                this.editorBusy = true
                if (this.editor) {
                    this.editor.enableSpellCheck = false;
                }

                try {
                    const { data: sfdt } = await axios.post(`${urlApi}/DOCXEditor/ImportFromUrl`, { url })
                    await this.abrirSfdtNoEditor(sfdt)
                    avisoToast('Documento carregado.', 'success')
                    await this.replaceTags()
                    await this.aplicarEstiloTodasTagsSollai()

                    this.limparHistoricoEditor()
                    this.forcarResizeEditor()
                } catch (e) {
                    this.editorBusy = false
                    this.setError(e?.response?.data || e.message || 'Erro ao abrir documento no editor.')
                }
            },

            limparHistoricoEditor() {
                try {
                    this.editor?.editorHistory?.clearHistory?.()
                } catch (e) {
                    console.warn('Falha ao limpar histórico do editor:', e)
                }
            },

            forcarResizeEditor() {
                const redimensionar = () => {
                    const container = this.$refs.docx?.ej2Instances
                    if (!container || container.isDestroyed) return
                    container.resize?.()
                    this.editor?.resize?.()
                }
                redimensionar()
                requestAnimationFrame(() => {
                    redimensionar()
                    setTimeout(redimensionar, 200)
                })
            },

            liberarDocumentoEditor() {
                const ed = this.editor
                if (!ed) return
                try {
                    ed.openBlank?.()
                    ed.editorHistory?.clearHistory?.()
                } catch (e) {
                    console.warn('Falha ao liberar documento do editor:', e)
                }
            },

            destruirEditor() {
                const container = this.$refs.docx?.ej2Instances
                if (!container) return
                try {
                    if (!container.isDestroyed && typeof container.destroy === 'function') {
                        container.destroy()
                    }
                } catch (e) {
                    console.warn('Falha ao destruir o editor Syncfusion:', e)
                }
            },

            async exportDocxBlob() {
                const ed = this.editor
                if (!ed) throw new Error('Editor não inicializado.')
                const blob = await ed.saveAsBlob('Docx');

                return blob
            },

            async exportDocxSerialize() {
                const ed = this.editor
                if (!ed) throw new Error('Editor não inicializado.')
                return ed.serialize()
                // return this.removerMarcaTextoTagsDoSfdt(ed.serialize())
            },

            async uploadToS3(blob, contentType, destino, ext) {
                const dto = this.modeloArtefatoPersonalizado || {}
                const uploaded = await uploadFileToS3(blob, {
                    destino,
                    fileName: `modelo.${ext}`,
                    contentType,
                    idProcesso: dto.idProcesso,
                    idProcessoModeloArtefato: dto.idProcessoModeloArtefato,
                })
                return uploaded.key
            },

            async salvarEdicao() {
                try {
                    this.loading = true
                    await this.salvarEdicaoInterno({ showToast: true })
                } catch (e) {
                    if (e.response.status == 500) {
                        avisoErro('Erro ao salvar as alterações. Devido a limitações do editor online, algumas funcionalidades nativas do Word podem não estar disponíveis. Caso o erro persista, recomendamos excluir o Modelo Personalizado e criá-lo novamente utilizando um novo arquivo.')
                    } else {
                        avisoErro(e?.message || 'Erro ao salvar alterações.')
                    }
                    
                } finally {
                    this.loading = false
                }
            },

            async salvarEdicaoInterno({ showToast = true } = {}) {
                if (!this.editor) {
                    throw new Error('Editor não inicializado.')
                }

                const dto = this.modeloArtefatoPersonalizado || {}
                if (!dto.idModeloArtefatoPersonalizado) {
                    throw new Error('ID do arquivo não encontrado.')
                }
                let flag = true;
                if (flag) {
                    // manda stdf para api
                    const serialize = await this.exportDocxSerialize();
                    const payload = {
                        idModeloArtefatoPersonalizado: dto.idModeloArtefatoPersonalizado,
                        content: serialize,
                    };
                    const { data } = await axios.post(`${urlApi}/ModeloArtefatoPersonalizado/SalvarEdicaoSerialize`, payload)
                    if (!data?.success) {
                        throw new Error(data?.msg || 'Não foi possível salvar a edição.')
                    }

                    this.modeloArtefatoPersonalizado.urlArquivo = dto.urlArquivo
                    this.fecharEditor();

                    if (showToast) {
                        avisoToast('Alterações salvas com sucesso.', 'success')
                    }

                } else {
                    // salva blob
                    const blob = await this.exportDocxBlob()
                    const mime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

                    const key = await this.uploadToS3(blob, mime, 'ModeloArtefatoPersonalizado', 'docx')
                    const payload = {
                        idModeloArtefatoPersonalizado: dto.idModeloArtefatoPersonalizado,
                        urlArquivoEdicao: key,
                    }
                    const { data } = await axios.post(`${urlApi}/ModeloArtefatoPersonalizado/SalvarEdicao`, payload)
                    if (!data?.success) {
                        throw new Error(data?.msg || 'Não foi possível salvar a edição.')
                    }


                    this.modeloArtefatoPersonalizado.urlArquivo = dto.urlArquivo
                    this.fecharEditor();

                    if (showToast) {
                        avisoToast('Alterações salvas com sucesso.', 'success')
                    }
                }
                

                return dto.urlArquivo
            },

            onEditorCreated() {
                const ed = this.editor
                if (!ed) return

                if (ed.selection) {
                    ed.selection.isHighlightContentControlEditRegion = true
                }

                if (ed.editorHistory) {
                    ed.editorHistory.undoLimit = 50
                    ed.editorHistory.redoLimit = 50
                }

                ed.documentChange = () => {
                    if (this.editorBusy) {
                        ed.isReadOnly = false
                        this.editorBusy = false
                    }
                }
            },

            beforeSend(args) {
                const raw = this.$store?.state?.authToken || localStorage.getItem('authToken')
                const auth = raw?.startsWith('Bearer ') ? raw : (raw ? `Bearer ${raw}` : '')
                if (auth) args.headers = [{ Authorization: auth }]
                args.withCredentials = false
            },

            onToolbarClick(args) {
                const txt = (args?.item?.text || '').toLowerCase()
                const id = (args?.item?.id || '').toLowerCase()
                if (txt === 'novo' || txt === 'abrir' || id.includes('new') || id.includes('open')) {
                    args.cancel = true
                    return
                }

                if (txt === 'salvar' || txt === 'save' || id.includes('save')) {
                    args.cancel = true
                    if (this.editorBusy) {
                        avisoToast('Aguarde o documento terminar de carregar…', 'warning')
                        return
                    }
                    this.salvarEdicao()
                    return
                }
                if (this.editorBusy) {
                    args.cancel = true
                    avisoToast('Aguarde o documento terminar de carregar…', 'warning')
                }
            },

            async abrirSfdtNoEditor(sfdt) {
                const ed = this.editor
                if (!ed) return

                await new Promise((resolve) => {
                    let concluido = false
                    const finalizar = () => {
                        if (concluido) return
                        concluido = true
                        clearTimeout(timeoutId)
                        ed.documentChange = handlerAnterior
                        this.$nextTick(() => setTimeout(resolve, 80))
                    }

                    const handlerAnterior = ed.documentChange
                    ed.documentChange = () => {
                        if (typeof handlerAnterior === 'function') {
                            handlerAnterior.call(this)
                        }
                        finalizar()
                    }

                    const timeoutId = setTimeout(finalizar, 5000)
                    ed.open(sfdt)
                })
            },

            ehTagSollaiMarcador(tag) {
                return typeof tag === 'string' && tag.startsWith('[**') && tag.endsWith('**]')
            },

            normalizarMarcadorTag(valor) {
                return (valor || '').replace(/\[\*\*|\*\*\]/g, '').trim().toLowerCase()
            },

            obterTextoInternoContentControl(contentControl) {
                if (!this.editor || !contentControl) return ''

                try {
                    this.editor.selection.selectContentControlInternal(contentControl)
                    return (this.editor.selection.text || '').trim()
                } catch {
                    return ''
                }
            },

            obterMarcadorTagDoControl(contentControl) {
                const props = contentControl?.contentControlProperties
                if (!props) return null

                const candidatos = [props.tag, props.title].filter(v => v != null && String(v).trim() !== '')
                for (const candidato of candidatos) {
                    if (this.ehTagSollaiMarcador(candidato)) return candidato

                    const nome = this.normalizarMarcadorTag(candidato)
                    const tagLista = (this.lstTags || []).find(
                        item => this.normalizarMarcadorTag(item.dsTag) === nome
                    )
                    if (tagLista) return tagLista.dsTag
                }

                const textoInterno = this.obterTextoInternoContentControl(contentControl)
                if (textoInterno) {
                    const nome = this.normalizarMarcadorTag(textoInterno)
                    const tagLista = (this.lstTags || []).find(
                        item => this.normalizarMarcadorTag(item.dsTag) === nome
                    )
                    if (tagLista) return tagLista.dsTag
                }

                return null
            },

            isContentControlTagSollai(contentControl) {
                return this.obterMarcadorTagDoControl(contentControl) != null
            },

            sincronizarMarcadorTagDoControl(contentControl) {
                const marcador = this.obterMarcadorTagDoControl(contentControl)
                if (!marcador || !this.editor) return

                const tagAtual = contentControl.contentControlProperties?.tag
                if (tagAtual === marcador) return

                this.editor.selection.selectContentControl(contentControl)
                const info = this.editor.selection.getContentControlInfo()
                if (!info) return

                info.tag = marcador
                info.canEdit = true
                info.canDelete = false
                this.editor.editor.setContentControlInfo(info)
            },

            criarSfdtConteudoTag(nome) {
                return {
                    sections: [{
                        blocks: [{
                            inlines: [{
                                characterFormat: { highlightColor: TAG_SOLLAI_HIGHLIGHT },
                                text: nome,
                            }],
                        }],
                    }],
                }
            },

            criarPropriedadesTag(tag, nome) {
                return {
                    alias: nome,
                    tag,
                    type: 'RichText',
                    canEdit: true,
                    canDelete: false,
                }
            },

            configurarContentControlTag(tag) {
                const existingCCP = this.editor?.selection?.getContentControlInfo()
                if (!existingCCP) return

                existingCCP.tag = tag
                existingCCP.canEdit = true
                existingCCP.canDelete = false
                this.editor.editor.setContentControlInfo(existingCCP)
            },

            aplicarMarcaTextoTag(contentControl) {
                if (!this.editor || !contentControl) return

                this.editor.selection.selectContentControlInternal(contentControl)
                this.editor.selection.characterFormat.highlightColor = TAG_SOLLAI_HIGHLIGHT
            },

            estaDentroDeContentControl() {
                const ctx = this.editor?.selection?.contextType || ''
                return ctx.includes('ContentControl')
            },

            sairDoContentControl(contentControl) {
                if (!this.editor) return

                const cc = contentControl || this.editor.selection.currentContentControl
                if (!cc?.reference) {
                    this.editor.selection.moveToNextCharacter()
                    return
                }

                this.editor.selection.selectContentControl(cc)
                const endIndex = this.editor.selection.endOffset
                if (endIndex) {
                    this.editor.selection.select(endIndex, endIndex)
                }

                let tentativas = 0
                while (this.estaDentroDeContentControl() && tentativas < 8) {
                    this.editor.selection.moveToNextCharacter()
                    tentativas++
                }
            },

            finalizarCursorAposInserirTag() {
                if (!this.editor) return

                this.editor.selection.characterFormat.highlightColor = 'NoColor'
                this.editor.editor.insertText(' ')

                this.editor.selection.moveToPreviousCharacter()
                this.editor.selection.characterFormat.highlightColor = 'NoColor'
                this.editor.selection.moveToNextCharacter()
                this.editor.selection.characterFormat.highlightColor = 'NoColor'
            },

            posicionarCursorAposTag(contentControl) {
                if (!this.editor) return

                this.sairDoContentControl(contentControl)
                this.finalizarCursorAposInserirTag()
            },

            obterTagSollaiSelecionada() {
                const cc = this.editor?.selection?.currentContentControl
                if (!cc) return null

                return this.isContentControlTagSollai(cc) ? cc : null
            },

            substituirTagSollaiSelecionada(tag, nome) {
                const contentControl = this.obterTagSollaiSelecionada()
                if (!contentControl) return false

                this.editor.selection.selectContentControl(contentControl)
                this.editor.editor.delete()
                this.inserirNovaTag(tag, nome, { inserirEspacoAntes: false })
                return true
            },

            inserirNovaTag(tag, nome, { inserirEspacoAntes = true } = {}) {
                const sfdtContent = this.criarSfdtConteudoTag(nome)
                const properties = this.criarPropriedadesTag(tag, nome)

                if (inserirEspacoAntes) {
                    this.editor.editor.insertText(' ')
                }

                this.editor.editor.insertContentControl(properties.type, sfdtContent, properties)
                this.configurarContentControlTag(tag)

                const contentControlInserido = this.editor.selection.currentContentControl
                this.aplicarMarcaTextoTag(contentControlInserido)
                this.posicionarCursorAposTag(contentControlInserido)
            },

            async aplicarEstiloTodasTagsSollai() {
                if (!this.editor?.editor?.getContentControls) return

                const controls = this.editor.editor.getContentControls() || []
                for (const cc of controls) {
                    if (!this.isContentControlTagSollai(cc)) continue

                    this.sincronizarMarcadorTagDoControl(cc)
                    this.aplicarMarcaTextoTag(cc)
                }

                this.editor.selection?.updateContentControlHighlightSelection?.()
            },

            /*
            // Mantido comentado: removia marca-texto das tags antes de salvar (comportamento anterior).
            removerMarcaTextoTagsDoSfdt(sfdtContent) {
                if (!sfdtContent) return sfdtContent

                let doc
                try {
                    doc = typeof sfdtContent === 'string' ? JSON.parse(sfdtContent) : sfdtContent
                } catch {
                    return sfdtContent
                }

                this.limparMarcaTextoTagsRecursivo(doc, false)
                return typeof sfdtContent === 'string' ? JSON.stringify(doc) : doc
            },

            limparMarcaTextoTagsRecursivo(node, dentroTagSollai) {
                if (!node || typeof node !== 'object') return

                if (Array.isArray(node)) {
                    node.forEach(item => this.limparMarcaTextoTagsRecursivo(item, dentroTagSollai))
                    return
                }

                let contextoTag = dentroTagSollai
                const props = node.contentControlProperties
                if (props?.tag && this.ehTagSollaiMarcador(props.tag)) {
                    contextoTag = true
                }

                if (contextoTag) {
                    if (node.characterFormat?.highlightColor && node.characterFormat.highlightColor !== 'NoColor') {
                        node.characterFormat.highlightColor = 'NoColor'
                    }
                    if (node.hc != null) {
                        delete node.hc
                    }
                }

                Object.values(node).forEach(val => {
                    if (val && typeof val === 'object') {
                        this.limparMarcaTextoTagsRecursivo(val, contextoTag)
                    }
                })
            },
            */

            inserirTag(tag) {
                if (!this.editor) return

                const nome = (tag || '').replace('[**', '').replace('**]', '')
                if (!this.substituirTagSollaiSelecionada(tag, nome)) {
                    this.inserirNovaTag(tag, nome)
                }
            },

            getTagKey(item, index) {
                // Índice sempre na key: tags com mesmo dsTag e id ausente/0
                // geravam '0_[**tag**]' duplicado e o Vue avisava Duplicate keys.
                return `${index}_${item.idModeloArtefatoTag || 0}_${item.dsTag || ''}`;
            },

            getNomeTag(item) {
                return (item?.dsTag || '').replace("[**", "").replace("**]", "");
            },

            temDescricaoTag(item) {
                return item && item.dsDescricao != null && String(item.dsDescricao).trim() !== '';
            },

            normalizarTagsLista(tags) {
                return (tags || []).map(tag => {
                    const descricao = tag.dsDescricao != null ? String(tag.dsDescricao).trim() : '';
                    return {
                        ...tag,
                        dsDescricao: descricao || null
                    };
                });
            },

            getDataBs(item) {
                if (this.temDescricaoTag(item))
                    return ` <span class="mb-0">${item.dsDescricao}</span> `;
                return '';
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },

            handleDragStart(e,tag) {
                e.dataTransfer.setData("text/plain", tag.dsTag);
                this.idDragging = tag.idModeloArtefatoTag;
            },
            handleDragEnd(e) {
                e.preventDefault();
                this.idDragging = null;
                //replaceTags();
            },

            onDrop(e) {
                const dsTag = e.dataTransfer.getData("text/plain");
                this.editor.selection.select({ x: e.offsetX, y: e.offsetY, extend: false });
                this.inserirTag(dsTag);
            },

            async replaceTags() {
                for (let index = 0; index < this.lstTags.length; index++) {
                    var item = this.lstTags[index];
                    const tagProcurada = item.dsTag;
                    // Configurar as opções de busca

                    // Usar a API de busca do editor
                    this.editor.search.findAll(tagProcurada);
                    if (this.editor.searchModule.searchResults.length > 0) {

                        var searchResults = this.editor.searchModule.searchResults;
                        if (searchResults && searchResults.length > 0) {
                            for (let i = searchResults.searchModule.textSearchResults.innerList.length - 1; i >= 0; i--) {
                                const result = searchResults.searchModule.textSearchResults.innerList[i];
                                this.editor.selection.selectRange(result.start, result.end);

                                const nomeTag = item.dsTag.replace("[**", '').replace("**]", '')
                                const defaultContent = this.criarSfdtConteudoTag(nomeTag)
                                const ccProperties = this.criarPropriedadesTag(item.dsTag, nomeTag)

                                this.editor.editor.insertText(" ");
                                this.editor.editor.insertContentControl(ccProperties.type, defaultContent, ccProperties);
                                this.configurarContentControlTag(item.dsTag);
                                this.aplicarMarcaTextoTag(this.editor.selection.currentContentControl);
                            }
                        }
                    }
                    
                }

                this.editor.search.searchResults.clear();
                         
            }
        },

        mounted: function () {
            this.load();
        },

        beforeDestroy: function () {
            clearTimeout(this.debounceTimeout);
            this.destruirEditor();
        },

        watch: {
            pagFilter: {
                handler() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        this.currentPage = 0;
                        this.getGrid();
                    }, 500);
                }
            },

            filtroTag() {
                this.montaPopover();
            },

            legislacaoSelecionadaId: function () {
                if (this.legislacaoSelecionadaId != null && this.legislacaoSelecionadaId != '') {
                    this.carregaModeloArtefato();
                }
            },

            editorBusy(val) {
                const c = this.$refs.docx?.ej2Instances
                if (!c) return
                if (val && c.showSpinner) c.showSpinner()
                if (!val && c.hideSpinner) c.hideSpinner()
            },
        }

    };
</script>
<style>
    /*.e-de-blink-cursor {
        border-image: linear-gradient(to right, #235FE8 0%, #00d084 100%) 1;
        border-radius: 5px;*/ /* this doesn't work */
        /*border-width: 3px;
        border-style: solid;
    }*/
</style>
<style lang="css" scoped>
    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }

    /* Header moderno */
    .btn-md{
        z-index: 1001;        
    }

    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 20px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #cbd5e1;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: center;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }
    }

    /* Tabela */
    .th-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        min-height: 20px;
    }

    .th-title {
        text-align: center;
        font-weight: 700;
        letter-spacing: 0.3px;
    }

    .table-container {
        display: flex;
        justify-content: center;
        padding: 32px 16px 0 16px;
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
    }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        border-collapse: collapse;
    }

    .custom-table th,
    .custom-table td {
        padding: 14px 18px;
        border-bottom: 1px solid #edf0f6;
        transition: background 0.2s ease;
    }

    .custom-table td {
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        font-size: 15px;
        color: #374151;
    }

    .custom-table th {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
        border-color: #374151;
    }

    [data-bs-theme="dark"] .custom-table th {
        background: #111827;
        color: #e5e7eb;
        border-bottom-color: #374151;
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e5e7eb;
        border-bottom-color: #374151;
    }

        [data-bs-theme="dark"] .custom-table td p {
            color: #e5e7eb;
        }

    .custom-table tbody tr:hover {
        background-color: rgba(59, 130, 246, 0.08);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: rgba(37, 99, 235, 0.25);
        color: #f8fafc;
    }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 10px 10px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .footer-records-text {
        font-size: 14px;
        font-weight: 600;
        color: #6b7280;
    }

    [data-bs-theme="dark"] .footer-records-text {
        color: #cbd5e1;
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
    }

    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #ffffff;
    }

    .page-box:hover {
        background-color: #f1f5f9;
        border-color: #2563eb;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
    }

    .page-box.disabled {
        opacity: 0.4;
        pointer-events: none;
    }

    [data-bs-theme="dark"] .page-box {
        background-color: #1f2937;
        border: 1px solid #334155;
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .page-box:hover {
        background-color: #334155;
        border-color: #3b82f6;
    }

    [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: white;
        border: 1px solid #2563eb;
    }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 16px;
        font-weight: 700;
    }

    /* Botões modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
        position: relative;
        overflow: hidden;
    }

    .modern-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .modern-btn:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .modern-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(37, 99, 235, 0.28);
    }

    .modern-btn:active {
        transform: translateY(0);
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    .modern-btn-light {
        background: linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%);
        color: #1d4ed8;
        border: 1px solid rgba(59, 130, 246, 0.35);
    }

    /* Campo de busca */
    .search-box {
        position: relative;
        flex: 1;
        max-width: 420px;
    }

    .tags-search-box {
        flex: none;
        max-width: none;
        width: 100%;
    }

    .tags-search-box .modern-search-input {
        padding: 8px 12px 8px 40px;
        font-size: 13px;
        border-radius: 999px;
    }

    .tags-search-box .search-icon {
        left: 12px;
        width: 14px;
        height: 14px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .modern-search-input:focus {
        background: #111827;
        border-color: #3b82f6;
    }

    [data-bs-theme="dark"] .modern-search-input::placeholder {
        color: #9ca3af;
    }

    /* Linhas customizadas */
    .model-title {
        font-weight: 700;
        font-size: 15px;
        color: #1f2937;
        margin-bottom: 4px;
    }

    .model-subtext {
        font-size: 12px;
        color: #6b7280;
        letter-spacing: 0.2px;
    }

    [data-bs-theme="dark"] .model-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .model-subtext {
        color: #cbd5e1;
    }

    /* Botões de ação */
    .action-buttons {
        display: inline-flex;
        gap: 8px;
        align-items: center;
    }

    .action-buttons.vertical {
        flex-direction: column;
        gap: 8px;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s ease;
        border: 2px solid transparent;
        position: relative;
        overflow: hidden;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        color: #1f2937;
    }

    .action-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .action-btn:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .action-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
    }

    .action-btn-light {
        background: linear-gradient(135deg, #f1f5f9 0%, #ffffff 100%);
        border: 2px solid #e2e8f0;
        color: #1f2937;
    }

    .action-btn-view {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
    }

    .action-btn-delete {
        background: transparent;
        color: #ef4444;
        border-color: #ef4444;
    }

    .action-btn-delete:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        border-color: transparent;
    }

    [data-bs-theme="dark"] .action-btn-light {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(17, 24, 39, 0.95) 100%);
        border-color: #475569;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .action-btn-light:hover {
            background: linear-gradient(135deg, rgba(51, 65, 85, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);
            border-color: #64748b;
            color: #f9fafb;
        }

    [data-bs-theme="dark"] .action-btn-delete {
        color: #f87171;
        border-color: #f87171;
    }

    @media (max-width: 768px) {
        .action-buttons.vertical {
            flex-direction: row;
            flex-wrap: wrap;
        }
    }

    /* Modal overlay */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(15, 23, 42, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        padding: 24px;
        backdrop-filter: blur(3px);
    }

    .modal-content {
        background: white;
        border-radius: 16px;
        width: 100%;
        max-width: 920px;
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-edicao {
        width: 98vw;
        max-width: 98vw;
        height: 96vh;
        max-height: 96vh;
        display: flex;
        flex-direction: column;
        overflow: visible;
        padding: 0 !important;
    }

    .modal-edicao > .btn.position-absolute {
        z-index: 20;
    }

    .modal-edicao .viewer-layout {
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
        overflow: hidden;
        border-radius: inherit;
    }

    /* Modal moderno */
    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 22px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-modern-header .header-icon {
        width: 60px;
        height: 60px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .modal-modern-header .header-text {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .modal-modern-header .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-modern-header .header-text p {
        margin: 0;
        font-size: 14px;
        color: #475569;
        max-width: 460px;
        line-height: 1.45;
    }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }

    select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .toggle-group {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
    }

    .toggle-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px 20px;
        font-size: 14px;
        font-weight: 600;
        color: #475569;
        background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);
        border: 2px solid rgba(148, 163, 184, 0.3);
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-height: 46px;
    }

    .toggle-btn.active {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
        border-color: rgba(37, 99, 235, 0.5);
    }

    .toggle-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
    }

    .upload-section {
        border: 2px dashed rgba(148, 163, 184, 0.35);
        border-radius: 14px;
        padding: 20px;
        background: rgba(241, 245, 249, 0.6);
    }

    .info-chip {
        display: inline-flex;
        align-items: flex-start;
        gap: 10px;
        padding: 14px 16px;
        border-radius: 12px;
        background: rgba(37, 99, 235, 0.08);
        color: #1e3a8a;
        font-size: 13px;
        line-height: 1.45;
    }

    .info-chip svg {
        flex-shrink: 0;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }

        .modal-modern-body {
            padding: 22px 18px;
        }

        .modal-modern-footer {
            padding: 0 18px 22px;
        }
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(16, 185, 129, 0.24) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .modal-content {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-body {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .form-control {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .form-control:focus {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .form-control::placeholder {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] select.form-control option {
        background: #1f2937;
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .info-chip {
        background: rgba(37, 99, 235, 0.18);
        color: #bfdbfe;
    }

    [data-bs-theme="dark"] .upload-section {
        background: rgba(30, 41, 59, 0.6);
        border-color: rgba(148, 163, 184, 0.35);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.92) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-btn-light {
        background: linear-gradient(135deg, rgba(29, 78, 216, 0.65) 0%, rgba(30, 64, 175, 0.8) 100%);
        color: #e0f2fe;
        border-color: rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .toggle-btn {
        color: #cbd5e1;
        background: rgba(15, 23, 42, 0.75);
        border-color: rgba(148, 163, 184, 0.25);
    }

    [data-bs-theme="dark"] .toggle-btn:hover {
        box-shadow: 0 6px 16px rgba(37, 99, 235, 0.18);
        transform: translateY(-1px);
    }

    [data-bs-theme="dark"] .toggle-btn.active {
        box-shadow: 0 6px 16px rgba(37, 99, 235, 0.32);
    }

    /* Editor tags */
    .tag {
        background: #f1f5f9;
        border: 1px solid #cbd5e1;
        padding: 6px 10px;
        margin: 4px 0;
        cursor: grab;
        border-radius: 6px;
        user-select: none;
        font-weight: 600;
        color: #1f2937;
    }

    .tag:active {
        cursor: grabbing;
        background: #dbeafe;
    }

    [data-bs-theme="dark"] .tag {
        background: rgba(30, 41, 59, 0.8);
        border-color: rgba(148, 163, 184, 0.25);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .tag:active {
        background: rgba(37, 99, 235, 0.35);
        color: #f8fafc;
    }

/* syncfusion*/
    /* Esconde os dois itens (match por aria-label e title em PT-BR) */
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[aria-label^="Crie um novo documento"]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[title^="Crie um novo documento"]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[aria-label^="Abra um documento"]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[title^="Abra um documento"]) {
        display: none !important;
    }

    /* Versão mais genérica (case-insensitive) — use se mudar o texto */
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[aria-label*="novo documento" i]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[title*="novo documento" i]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[aria-label*="abra um documento" i]),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-toolbar-item[title*="abra um documento" i]) {
        display: none !important;
    }

    /* Some com o separador imediatamente antes desses itens (suporta e-separator e e-tbar-separator) */
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-separator:has(+ .e-toolbar-item[aria-label^="Crie um novo documento"])),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-separator:has(+ .e-toolbar-item[aria-label^="Abra um documento"])),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-tbar-separator:has(+ .e-toolbar-item[aria-label^="Crie um novo documento"])),
    :deep(.e-documenteditorcontainer .e-de-toolbar .e-tbar-separator:has(+ .e-toolbar-item[aria-label^="Abra um documento"])) {
        display: none !important;
    }

    .blocker-success {
        border-color: #16a34a;
        color: #065f46;
    }

    .completion-container {
        position: relative;
        height: calc(100vh - var(--appbar-height));
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px;
        overflow: hidden;
    }

    .completion-bg {
        position: absolute;
        inset: 0;
        background: radial-gradient(circle at 20% 20%, rgba(56, 189, 248, 0.25), transparent 55%), radial-gradient(circle at 80% 30%, rgba(16, 185, 129, 0.35), transparent 60%), radial-gradient(circle at 50% 80%, rgba(59, 130, 246, 0.3), transparent 55%);
        filter: blur(60px);
        opacity: 0.65;
        transform: scale(1.2);
        pointer-events: none;
    }

    .completion-card {
        position: relative;
        display: flex;
        align-items: center;
        gap: 36px;
        padding: 36px 40px;
        border-radius: 28px;
        box-shadow: 0 30px 70px rgba(15, 23, 42, 0.12);
        backdrop-filter: blur(12px);
        color: #0f172a;
        overflow: hidden;
        max-width: 820px;
        width: 100%;
        animation: fadeUp 0.5s ease-out;
    }

        .completion-card::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: inherit;
            border: 1px solid rgba(255, 255, 255, 0.35);
            pointer-events: none;
        }

    .completion-card-success {
        background: linear-gradient(135deg, rgba(110, 231, 183, 0.25), rgba(5, 150, 105, 0.4));
    }

    .completion-card-primary {
        background: linear-gradient(135deg, rgba(96, 165, 250, 0.25), rgba(37, 99, 235, 0.45));
    }

    .completion-icon {
        position: relative;
        flex-shrink: 0;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        display: grid;
        place-items: center;
        background: rgba(255, 255, 255, 0.45);
        color: #0f172a;
        box-shadow: 0 20px 45px rgba(15, 23, 42, 0.15);
    }

        .completion-icon svg {
            width: 60px;
            height: 60px;
        }

    .completion-spark {
        position: absolute;
        inset: 8px;
        border-radius: inherit;
        border: 1px solid rgba(15, 23, 42, 0.08);
        animation: pulse 2.8s ease-in-out infinite;
    }

    .completion-content {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

        .completion-content h3 {
            font-size: 2rem;
            font-weight: 700;
            color: #0f172a;
            margin: 0;
            line-height: 1.2;
        }

        .completion-content p {
            font-size: 1rem;
            line-height: 1.6;
            color: rgba(15, 23, 42, 0.75);
            margin: 0;
            max-width: 520px;
        }

    .completion-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
    }

        .completion-actions button {
            min-width: 190px;
        }

    .btn-solid,
    .btn-outline {
        border-radius: 999px;
        padding: 12px 24px;
        font-weight: 600;
        font-size: 0.95rem;
        border: none;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
        box-shadow: 0 14px 30px rgba(15, 23, 42, 0.15);
    }

    .btn-solid {
        background: linear-gradient(135deg, #16a34a, #0f766e);
        color: #fff;
    }

        .btn-solid:hover {
            transform: translateY(-2px);
            box-shadow: 0 18px 40px rgba(15, 23, 42, 0.2);
            background: linear-gradient(135deg, #15803d, #0d9488);
        }

    .btn-outline {
        background: rgba(255, 255, 255, 0.9);
        color: #0f172a;
        border: 1px solid rgba(15, 23, 42, 0.1);
        backdrop-filter: blur(6px);
    }

        .btn-outline:hover {
            transform: translateY(-2px);
            box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
            background: rgba(255, 255, 255, 0.98);
        }

    .completion-card-primary .btn-solid {
        background: linear-gradient(135deg, #2563eb, #1d4ed8);
    }

        .completion-card-primary .btn-solid:hover {
            background: linear-gradient(135deg, #1d4ed8, #1e40af);
        }

    @keyframes fadeUp {
        from {
            opacity: 0;
            transform: translateY(24px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            opacity: 0.35;
        }

        50% {
            opacity: 0.65;
        }
    }

    @media (max-width: 920px) {
        .completion-card {
            flex-direction: column;
            text-align: center;
            padding: 28px 24px 32px;
        }

        .completion-icon {
            width: 96px;
            height: 96px;
        }

        .completion-content {
            align-items: center;
        }

            .completion-content h3 {
                font-size: 1.7rem;
            }

        .completion-actions {
            justify-content: center;
        }

            .completion-actions button {
                flex: 1 1 140px;
            }
    }

    .docx-wrapper {
        /*flex: 3 1 0;*/
        flex: 1 1 auto;
        max-height: 100%;
        width: 100%;
        height: 100%;
        min-width: 0;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .e-documenteditor,
    .e-de-container,
    .e-de-ctn{
        height: 100% !important;
        width: 100% !important;
        box-sizing: border-box;
    }
    .e-de-editor{
        height: 100% !important;
    }

    .pdf-wrapper {
        flex: 3 1 0;
    }

    .pdf-host {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .viewer-layout {
        display: flex;
        gap: 0;
        height: 100%;
        min-height: 0;
        overflow: hidden;
    }

        .viewer-layout > * {
            min-width: 0;
            min-height: 0;
            box-sizing: border-box;
        }

    .side-panel {
        flex: 0 1 clamp(300px, 32vw, 440px);
        width: clamp(300px, 32vw, 440px);
        max-width: 100%;
        min-width: 0;
        height: 100%;
        padding: clamp(12px, 1.5vw, 24px) clamp(10px, 1.2vw, 20px);
        display: flex;
        flex-direction: column;
        gap: clamp(12px, 1.4vh, 20px);
        overflow: hidden;
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-left: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 0 16px 16px 0;
    }

    .panel-header {
        background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
        border-radius: 16px;
        padding: clamp(16px, 2vh, 24px) clamp(14px, 1.4vw, 22px);
        color: white;
        box-shadow: 0 8px 24px rgba(35, 95, 232, 0.25);
        display: flex;
        gap: clamp(10px, 1vw, 16px);
        align-items: center;
        flex-shrink: 0;
        min-height: 88px;
        animation: slideInRight 0.4s ease-out;
    }

    .header-icon {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        flex-shrink: 0;
    }

        .header-icon svg {
            width: 24px;
            height: 24px;
            color: white;
        }

    .header-content {
        flex: 1;
        min-width: 0;
    }

    .titulo-artefato {
        margin: 0;
        font-size: clamp(0.75rem, 0.85vw, 0.875rem);
        font-weight: 700;
        line-height: 1.35;
        color: white;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        overflow-wrap: break-word;
        word-break: break-word;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }

    .sub {
        margin: 0 0 10px 0;
        font-size: 0.9rem;
        opacity: 0.95;
        color: rgba(255, 255, 255, 0.95);
        line-height: 1.4;
    }

    .codigo-badge {
        display: inline-block;
        background: rgba(255, 255, 255, 0.25);
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 0.8rem;
        font-weight: 600;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.3);
    }

    .info-card {
        background: white;
        border-radius: 14px;
        padding: clamp(12px, 1.4vh, 18px);
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        border: 1px solid rgba(0, 0, 0, 0.05);
        transition: box-shadow 0.3s ease;
        animation: slideInRight 0.4s ease-out;
        animation-fill-mode: both;
        min-width: 0;
    }

        .info-card:hover {
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

    .status-card {
        animation-delay: 0.1s;
    }

    .tags-card {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: clamp(10px, 1.2vh, 14px);
        overflow: hidden;
    }

    .tags-card .card-title {
        margin-bottom: 0;
        flex-shrink: 0;
    }

    .tags-card .tags-search-box {
        flex-shrink: 0;
        margin-bottom: 0;
    }

    .tags-card .tags-list {
        flex: 1 1 auto;
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .details-card {
        animation-delay: 0.2s;
    }

    .card-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 0.85rem;
        font-weight: 600;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 14px;
    }

        .card-title svg {
            opacity: 0.7;
        }

    .status-badge {
        display: inline-block;
        padding: 10px 18px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.95rem;
        text-align: center;
        width: 100%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        background: linear-gradient(135deg, #a8e6cf 0%, #56ccf2 100%);
        color: #155724;
    }

    .status-revisao {
        background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
        color: #856404;
    }

    .status-aprovacao {
        background: linear-gradient(135deg, #a8e6cf 0%, #56ccf2 100%);
        color: #155724;
    }

    .info-grid {
        display: grid;
        gap: 14px;
    }

    .info-item {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 12px;
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-radius: 10px;
        border-left: 3px solid #235FE8;
        transition: all 0.3s ease;
    }

        .info-item:hover {
            border-left-color: #00d084;
            transform: translateX(2px);
        }

        .info-item .label {
            font-size: 0.8rem;
            font-weight: 600;
            color: #6c757d;
            text-transform: uppercase;
            letter-spacing: 0.3px;
        }

        .info-item .value {
            font-size: 0.95rem;
            font-weight: 600;
            color: #2d3748;
            line-height: 1.4;
        }

    .acoes-section {
        margin-top: 0;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        animation: slideInRight 0.4s ease-out;
        animation-delay: 0.3s;
        animation-fill-mode: both;
    }

    .side-panel .btn-action {
        width: 100%;
        padding: clamp(10px, 1.2vh, 14px) clamp(12px, 1.2vw, 20px);
        font-size: clamp(0.82rem, 0.95vw, 0.95rem);
    }

    @media (max-width: 1200px) {
        .side-panel {
            flex-basis: clamp(280px, 34vw, 380px);
            width: clamp(280px, 34vw, 380px);
        }
    }

    @media (max-height: 720px) {
        .side-panel {
            gap: 10px;
            padding: 10px 12px;
        }

        .panel-header {
            padding: 12px 14px;
            border-radius: 12px;
            min-height: 72px;
        }

        .titulo-artefato {
            font-size: 0.75rem;
            -webkit-line-clamp: 3;
            line-clamp: 3;
        }

        .header-icon {
            padding: 8px;
            border-radius: 10px;
        }

        .header-icon svg {
            width: 18px;
            height: 18px;
        }

        .tags-card {
            padding: 10px 12px;
            gap: 8px;
        }

        .side-panel .card-title {
            margin-bottom: 0;
            font-size: 0.75rem;
        }
    }

    .acoes-title {
        font-size: 0.85rem;
        font-weight: 700;
        color: #495057;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
    }

    /* Botões de Ação */
    .btn-action {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 14px 20px;
        border: none;
        border-radius: 12px;
        font-size: 0.95rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: hidden;
        color: white;
    }

        .btn-action::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%) scale(0);
            transition: transform 0.6s ease;
            pointer-events: none;
        }

        .btn-action:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .btn-action:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none !important;
        }

        .btn-action:not(:disabled):hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
        }

        .btn-action:not(:disabled):active {
            transform: translateY(0);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .btn-action svg {
            flex-shrink: 0;
            position: relative;
            z-index: 1;
        }

        .btn-action span {
            flex: 1;
            text-align: center;
            position: relative;
            z-index: 1;
        }

    .btn-primary {
        background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
        box-shadow: 0 4px 12px rgba(35, 95, 232, 0.3);
    }

        .btn-primary:not(:disabled):hover {
            background: linear-gradient(135deg, #1e50c9 0%, #00b872 100%);
            box-shadow: 0 8px 24px rgba(35, 95, 232, 0.4);
        }

        .btn-primary:not(:disabled):active {
            background: linear-gradient(135deg, #1a47b5 0%, #009f65 100%);
        }

    .btn-outline-primary {
        background: transparent;
        border: 2px solid #235FE8;
        color: #235FE8;
        box-shadow: 0 2px 8px rgba(35, 95, 232, 0.15);
    }

        .btn-outline-primary:not(:disabled):hover {
            background: rgba(35, 95, 232, 0.1);
            border-color: #1e50c9;
            color: #1e50c9;
            box-shadow: 0 4px 16px rgba(35, 95, 232, 0.25);
        }

        .btn-outline-primary:not(:disabled):active {
            background: rgba(35, 95, 232, 0.2);
            border-color: #1a47b5;
            color: #1a47b5;
        }

    .btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }

        .btn-success:not(:disabled):hover {
            background: linear-gradient(135deg, #0ea374 0%, #047857 100%);
            box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4);
        }

        .btn-success:not(:disabled):active {
            background: linear-gradient(135deg, #0c8d63 0%, #036547 100%);
        }

    .btn-danger {
        background: linear-gradient(135deg, #f43f5e 0%, #e11d48 100%);
        box-shadow: 0 4px 12px rgba(244, 63, 94, 0.3);
    }

        .btn-danger:not(:disabled):hover {
            background: linear-gradient(135deg, #e11d48 0%, #be123c 100%);
            box-shadow: 0 8px 24px rgba(244, 63, 94, 0.4);
        }

        .btn-danger:not(:disabled):active {
            background: linear-gradient(135deg, #be123c 0%, #9f1239 100%);
        }

    .btn-warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
    }

        .btn-warning:not(:disabled):hover {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
            box-shadow: 0 8px 24px rgba(245, 158, 11, 0.4);
        }

        .btn-warning:not(:disabled):active {
            background: linear-gradient(135deg, #b45309 0%, #92400e 100%);
        }

    /* Animações */
    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(20px);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    /* Scrollbar customizada */
    .side-panel::-webkit-scrollbar {
        width: 6px;
    }

    .side-panel::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
    }

    .side-panel::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
        border-radius: 10px;
    }

        .side-panel::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(135deg, #1e50c9 0%, #00b872 100%);
        }

    .blocker {
        height: calc(100vh - var(--appbar-height));
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 24px;
        gap: 12px;
    }

        .blocker .motivo {
            max-width: 720px;
            opacity: .85;
            font-size: 0.95rem;
        }

        .blocker .btn {
            padding: 10px 16px;
            border-radius: 10px;
            border: none;
            cursor: pointer;
        }

    .editor-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(4px);
    }

    .overlay-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

        .overlay-content p {
            font-size: 1.1rem;
            font-weight: 600;
            color: #235FE8;
            margin: 0;
        }

    .spinner {
        width: 50px;
        height: 50px;
        animation: rotate 2s linear infinite;
    }

        .spinner circle {
            stroke: #235FE8;
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }

        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }

        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

    .is-loading {
        position: relative;
    }

    /* ========== DARK THEME - SIDE PANEL ONLY ========== */
    [data-bs-theme="dark"] .side-panel {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        border-left: 1px solid rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .completion-container {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(30, 41, 59, 0.95) 100%);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .completion-card {
        box-shadow: 0 30px 70px rgba(15, 23, 42, 0.45);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .completion-card-success {
        background: linear-gradient(135deg, rgba(34, 197, 94, 0.22), rgba(5, 150, 105, 0.38));
    }

    [data-bs-theme="dark"] .completion-card-primary {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.25), rgba(59, 130, 246, 0.4));
    }

    [data-bs-theme="dark"] .completion-content p {
        color: rgba(226, 232, 240, 0.85);
    }

    [data-bs-theme="dark"] .completion-content h3 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .completion-icon {
        background: rgba(255, 255, 255, 0.12);
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .btn-outline {
        background: rgba(226, 232, 240, 0.12);
        color: #e2e8f0;
        border-color: rgba(148, 163, 184, 0.35);
    }

        [data-bs-theme="dark"] .btn-outline:hover {
            background: rgba(226, 232, 240, 0.24);
            box-shadow: 0 18px 40px rgba(37, 99, 235, 0.25);
        }

    [data-bs-theme="dark"] .panel-header {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 8px 24px rgba(96, 165, 250, 0.3);
    }

    [data-bs-theme="dark"] .header-icon {
        background: rgba(255, 255, 255, 0.25);
    }

    [data-bs-theme="dark"] .titulo-artefato,
    [data-bs-theme="dark"] .sub,
    [data-bs-theme="dark"] .codigo-badge {
        color: white;
    }

    [data-bs-theme="dark"] .codigo-badge {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.25);
    }

    [data-bs-theme="dark"] .info-card {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    }

        [data-bs-theme="dark"] .info-card:hover {
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.2);
            border-color: rgba(96, 165, 250, 0.3);
        }

    [data-bs-theme="dark"] .card-title {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .status-badge {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
        color: #ecfdf5;
        font-weight: 700;
    }

    [data-bs-theme="dark"] .status-revisao {
        background: linear-gradient(135deg, rgba(251, 191, 36, 0.35) 0%, rgba(245, 158, 11, 0.45) 100%);
        color: #fde68a;
    }

    [data-bs-theme="dark"] .status-aprovacao {
        background: linear-gradient(135deg, rgba(52, 211, 153, 0.35) 0%, rgba(16, 185, 129, 0.45) 100%);
        color: #a7f3d0;
    }

    [data-bs-theme="dark"] .info-item {
        background: linear-gradient(135deg, #2d3548 0%, #353d52 100%);
        border-left-color: #60a5fa;
    }

        [data-bs-theme="dark"] .info-item:hover {
            border-left-color: #34d399;
            background: linear-gradient(135deg, #353d52 0%, #3d4558 100%);
        }

        [data-bs-theme="dark"] .info-item .label {
            color: #cbd5e1;
        }

        [data-bs-theme="dark"] .info-item .value {
            color: #f3f4f6;
        }

    [data-bs-theme="dark"] .acoes-title {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .btn-action {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
    }

        [data-bs-theme="dark"] .btn-action:not(:disabled):hover {
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.3);
        }

    [data-bs-theme="dark"] .btn-primary {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);
    }

        [data-bs-theme="dark"] .btn-primary:not(:disabled):hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.5);
        }

        [data-bs-theme="dark"] .btn-primary:not(:disabled):active {
            background: linear-gradient(135deg, #2563eb 0%, #059669 100%);
        }

    [data-bs-theme="dark"] .btn-outline-primary {
        background: transparent;
        border: 2px solid #60a5fa;
        color: #60a5fa;
        box-shadow: 0 2px 8px rgba(96, 165, 250, 0.2);
    }

        [data-bs-theme="dark"] .btn-outline-primary:not(:disabled):hover {
            background: rgba(96, 165, 250, 0.15);
            border-color: #3b82f6;
            color: #3b82f6;
            box-shadow: 0 4px 16px rgba(96, 165, 250, 0.3);
        }

        [data-bs-theme="dark"] .btn-outline-primary:not(:disabled):active {
            background: rgba(96, 165, 250, 0.25);
            border-color: #2563eb;
            color: #2563eb;
        }

    [data-bs-theme="dark"] .btn-success {
        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
        box-shadow: 0 4px 12px rgba(52, 211, 153, 0.4);
    }

        [data-bs-theme="dark"] .btn-success:not(:disabled):hover {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            box-shadow: 0 8px 24px rgba(52, 211, 153, 0.5);
        }

        [data-bs-theme="dark"] .btn-success:not(:disabled):active {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
        }

    [data-bs-theme="dark"] .btn-danger {
        background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
        box-shadow: 0 4px 12px rgba(248, 113, 113, 0.4);
    }

        [data-bs-theme="dark"] .btn-danger:not(:disabled):hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            box-shadow: 0 8px 24px rgba(248, 113, 113, 0.5);
        }

        [data-bs-theme="dark"] .btn-danger:not(:disabled):active {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
        }

    [data-bs-theme="dark"] .btn-warning {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
        box-shadow: 0 4px 12px rgba(251, 191, 36, 0.4);
    }

        [data-bs-theme="dark"] .btn-warning:not(:disabled):hover {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            box-shadow: 0 8px 24px rgba(251, 191, 36, 0.5);
        }

        [data-bs-theme="dark"] .btn-warning:not(:disabled):active {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
        }

    [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
    }

    [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
    }

        [data-bs-theme="dark"] .side-panel::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }

    [data-bs-theme="dark"] .blocker {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        color: #f3f4f6;
    }

        [data-bs-theme="dark"] .blocker h3 {
            color: #ffffff;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        [data-bs-theme="dark"] .blocker .motivo {
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] .blocker-success {
            border-color: #34d399;
            color: #a7f3d0;
        }

        [data-bs-theme="dark"] .blocker .btn {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.3);
            transition: all 0.3s ease;
        }

            [data-bs-theme="dark"] .blocker .btn:hover {
                background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
                box-shadow: 0 8px 24px rgba(96, 165, 250, 0.4);
                transform: translateY(-2px);
            }

    [data-bs-theme="dark"] .editor-overlay {
        background: rgba(26, 31, 46, 0.95);
    }

    [data-bs-theme="dark"] .overlay-content p {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .spinner circle {
        stroke: #60a5fa;
    }


    /* ========================================
   ITEMS DO HISTÓRICO MODERNIZADOS
   ======================================== */
    .tyn-aside-list {
        .tyn-aside-item
        {
            border-radius: 10px;
            margin-bottom: 0.5rem;
            padding: 0.75rem 0.2rem;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 2px solid transparent;
            cursor: pointer;
            &:hover

        {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
            border-color: rgba(31, 123, 255, 0.15);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);
            .content

        {
            color: #1f7bff;
        }

        }

        &.active {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.12) 0%, rgba(0, 208, 132, 0.12) 100%);
            border-color: #1f7bff;
            box-shadow: 0 3px 10px rgba(31, 123, 255, 0.2);
            /*transform: translateX(6px);*/

            .content

        {
            color: #1f7bff;
            font-weight: 600;
        }

        }
        }

        .content {
            font-size: 0.9rem;
            line-height: 1.4;
            color: #2d3748;
            transition: all 0.3s ease;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .content-descricao {
            font-size: 0.78rem;
            line-height: 1.35;
            color: #64748b;
            margin-top: 0.15rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .tyn-media-group {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            cursor: grab;
            min-width: 0;
            width: 100%;
        }

            .tyn-media-group.dragging {
                opacity: 0.6;
                transform: scale(0.98);
                background-color: #e9f0fb;
                border-color: #2b579a;
                cursor: grab;
            }
            .tyn-media-group.dragging:active {
                cursor: grabbing;
            }

        .tyn-media-col {
            flex: 1 1 auto;
            min-width: 0;
        }

        .tyn-media-option {
            flex-shrink: 0;
        }

        .tyn-media {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
            border-radius: 8px;
            transition: all 0.3s ease;
            svg

        {
            fill: #1f7bff;
        }

        }

        .tyn-aside-item:hover .tyn-media {
            opacity: 0;
            width: 0;
            min-width: 0;
            margin: 0;
            padding: 0;
            overflow: hidden;
            transform: none;
            pointer-events: none;
        }

        .tyn-aside-item.active .tyn-media {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.3);
            svg

        {
            fill: white;
        }

        }

        /* Meta Info - Status Badges */
        .meta-info {
            margin-top: 0.25rem;
            display: flex;
            gap: 0.5rem;
            align-items: center;
        }

        .btn-success-add {
            background: linear-gradient(135deg, #1d4ed8, #00bf51) !important;
            box-shadow: 0 2px 8px rgba(37, 99, 235, .2);
            color: #fff !important;
        }
    }

    [data-bs-theme="dark"] .tyn-aside-list {
        .content {
            color: #e5e7eb;
        }

        .content-descricao {
            color: #cbd5e1;
        }

        .tyn-aside-item:hover .content {
            color: #93c5fd;
        }

        .tyn-aside-item.active .content {
            color: #93c5fd;
        }

        .tyn-aside-item:hover {
            background: linear-gradient(135deg, rgba(96, 165, 250, 0.12) 0%, rgba(52, 211, 153, 0.12) 100%);
            border-color: rgba(96, 165, 250, 0.3);
        }

        .tyn-aside-item.active {
            background: linear-gradient(135deg, rgba(96, 165, 250, 0.18) 0%, rgba(52, 211, 153, 0.18) 100%);
            border-color: #60a5fa;
        }

        .tyn-media {
            background: linear-gradient(135deg, rgba(96, 165, 250, 0.2) 0%, rgba(52, 211, 153, 0.2) 100%);

            svg {
                fill: #93c5fd;
            }
        }

        .tyn-media-group.dragging {
            background-color: rgba(37, 99, 235, 0.3);
            border-color: #60a5fa;
        }
    }

</style>

